// **********************************************************
// Main menu dropdown
// **********************************************************

const megaMenuItems = document.querySelectorAll('.mega-menu__item.level-1');

attachEvent('.menu__arrow', 'click', (ev) => {
  if (windowWidth() < breakpointMd) {
    const arrowParent = ev.target.closest('.menu__item');
    const menuDropdown = arrowParent.querySelector('.mega-menu');

    arrowParent.classList.toggle('is-open-submenu');
    slideToggle(menuDropdown, 300, 'block');
  }
});

attachEvent('.mega-menu__arrow', 'click', (ev) => {
  if (windowWidth() < breakpointMd) {
    const arrowParent = ev.target.closest('.mega-menu__item');
    const menuDropdown = arrowParent.querySelector('.mega-menu__dropdown');

    arrowParent.classList.toggle('is-open-submenu');
    slideToggle(menuDropdown, 300, 'block');
  }
});

// Mouse hover on megamenu items

megaMenuItems.forEach((ev) => {
  ev.addEventListener('mouseover', (el) => {
    const parentElem = el.target.closest('.mega-menu__item.level-1.has-sub');
    const parentMegaMenu = el.target.closest('.mega-menu');
    if (parentElem) {
      const menuDrown = parentElem.querySelector('.mega-menu__dropdown');
      const submenuHeight = menuDrown.clientHeight + 80;
      parentMegaMenu.style.setProperty('--submenu-height', `${submenuHeight}px`);
    }
  });

  ev.addEventListener('mouseout', (el) => {
    const parentMegaMenu = el.target.closest('.mega-menu');
    parentMegaMenu.style.setProperty('--submenu-height', '1px');
  });
});
